import { render, staticRenderFns } from "./cart-gift-wrap.vue?vue&type=template&id=27cc234a&"
import script from "./cart-gift-wrap.vue?vue&type=script&lang=js&"
export * from "./cart-gift-wrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports